<template>
  <h-form-box class="he-use-form" :form-data="formData">
    <template v-if="formData.formDataList">
      <template v-if="custom">
        <slot
          v-for="li in formData.formDataList"
          :data="li"
          type="ShowForm"
          :prop="li.fieldId"
          :model="formData.model"
        />
      </template>
      <which-element
        v-for="li in formData.formDataList"
        v-else
        :key="li.fieldId"
        :data="li"
        type="ShowForm"
        :prop="li.fieldId"
        :model="formData.model"
      />
    </template>
  </h-form-box>
</template>

<script>
import WhichElement from './components/which-element.vue'
import HFormBox from './common/FormBox.vue'
export default {
  name: 'HUseForm',
  components: { WhichElement, HFormBox },
  provide() {
    return {
      formData: this.formData,
      contentSelectChange: null
    }
  },
  props: {
    custom: Boolean,
    formData: {
      type: Object,
      required: true
      /**
       * formDataList: [],
       * formStyle: { }
       */
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../index.scss";
.he-use-form {
  width: 100%;
  height: 100%;
}
</style>
